import script from "./DeleteProjectConfirmDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteProjectConfirmDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./DeleteProjectConfirmDropdown.vue?vue&type=style&index=0&id=780661fb&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-780661fb"]])

export default __exports__